module.exports = __webpack_public_path__ + "media/images/vp/icon.in.white-50bc4c0b7b7bdbacfe92e02a6ed84149.png";